import { Action, ACTION_TYPE, ERROR_CODE } from '@abiglobalhealth/go-types'

import { actionsRequest } from '@/api/utils'

import { handleSession } from './session'

export const getInitialModule = async <T extends Action<ACTION_TYPE.GET_INITIAL_MODULE>>(
  payload: T['payload'],
  signal?: AbortSignal
): Promise<T['response']> => {
  const body = await actionsRequest<T>(
    {
      payload,
      type: ACTION_TYPE.GET_INITIAL_MODULE
    },
    signal
  )

  if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

  const { user, module } = body.data

  // Get current session or create a new one and return it
  await handleSession({
    uniqueId: user?.data?.uniqueId!
  })

  return {
    user,
    module
  }
}

export const getNextModule = async <T extends Action<ACTION_TYPE.GET_NEXT_MODULE>>({ uniqueId, moduleId }: T['payload']): Promise<T['response']> => {
  const body = await actionsRequest<T>({
    payload: {
      uniqueId,
      moduleId
    },
    type: ACTION_TYPE.GET_NEXT_MODULE
  })

  if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

  const { module } = body.data

  return {
    module
  }
}

export const getPreviousModule = async <T extends Action<ACTION_TYPE.GET_PREVIOUS_MODULE>>({ uniqueId }: T['payload']): Promise<T['response']> => {
  const body = await actionsRequest<T>({
    payload: {
      uniqueId
    },
    type: ACTION_TYPE.GET_PREVIOUS_MODULE
  })

  if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

  const { module } = body.data

  return {
    module
  }
}
